import { useMemo } from 'react'

interface PasswordValidation {
  hasMinLength: boolean
  hasLetter: boolean
  hasNumber: boolean
  hasSpecialChar: boolean
  isValid: boolean
}

export const usePasswordValidation = (password: string): PasswordValidation => {
  return useMemo(() => {
    const hasMinLength = password.length >= 12
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasNumber = /\d/.test(password)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>\-_+=\[\];'/\\`~]/.test(password)
    const isValid = hasMinLength && hasLetter && hasNumber && hasSpecialChar

    return {
      hasMinLength,
      hasLetter,
      hasNumber,
      hasSpecialChar,
      isValid
    }
  }, [password])
}
